<template>
  <v-app>
    <router-view />
  </v-app>
</template>
<style>
* {
  font-family: "Poppins", sans-serif !important;
}

.v-navigation-drawer__content {
  scrollbar-width: thin !important;
  /* Firefox */
  scrollbar-color: lightgray !important;
}

.cursorPointer {
  cursor: pointer !important;
}

.fontVariant0 {
  font-size: 10px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.fontVariant1 {
  font-size: 12px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.fontVariant2 {
  font-size: 14px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.fontVariant3 {
  font-size: 16px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.fontVariant4 {
  font-size: 18px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.fontVariant5 {
  font-size: 20px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.tableClassVariant1 table {
  border-collapse: separate;
  border-spacing: 0 0px !important;
}

.greyTextNavTitle {
  color: #eef2f6 !important;
}

.tableClassVariant1 th {
  height: 24px !important;
  text-align: center;
  border: 1px solid #d5d7dd;
  padding: 5px;
  font-size: 12px !important;
}

.tableClassVariant1.v-table td {
  height: 24px !important;
  font-weight: normal !important;
  font-size: 12px !important;
}

.tableClassVariant1 th {
  background-image: linear-gradient(#f6faff, #d5d7dd);
  color: #8e8484 !important;
  border-bottom: 1px solid #d5d7dd !important;
}

.tableClassVariant1 table th:first-child {
  border-radius: 4px 0 0 4px;
}

.tableClassVariant1 table th:last-child {
  border-radius: 0px 0px 0px 0px;
}

.tableClassVariant1 td:first-child {
  border-radius: 0px 0px 0px 0px;
}

.tableClassVariant1 td:last-child {
  border-radius: 0px 6px 6px 0px;
}

.tableClassVariant1 tr:nth-child(even) {
  background-color: #f6faff !important;
}

.field_height .v-field {
  min-height: 12px !important;
  max-height: 33px !important;
  display: flex !important;
  align-items: center !important;
}

.field_label_size.v-input .v-label {
  font-size: 10px !important;
  opacity: 1 !important;
  /* font-family: "Poppins", sans-serif !important */
}

.field_font .v-field__input {
  font-size: 12px !important;
  /* font-family: "Poppins", sans-serif !important */
}

.v-navigation-drawer {
  border-right: none !important;
}
</style>
